import { ApiPath } from 'common/enums/http/api-path';
import type { ResponseWithPagination } from 'common/types';
import type { FleetPurchasesHistory } from 'models/fleet-purchases-history';
import { http } from 'services/http';

export const getFleetPurchasesHistoryApi = (params?: string) =>
  http.get<ResponseWithPagination<FleetPurchasesHistory>>(
    `${ApiPath.FLEET_PURCHASES_HISTORY}${params || ''}`
  );
